import makeStateFilter from '../../../make-state-filter';

import { stateFilter as parentStateFilter } from '../returns.reducer.metadata';

const namespace = 'grid';
const stateFilter = makeStateFilter(parentStateFilter, namespace);

export { namespace, stateFilter };
